import React, { forwardRef } from 'react'
import { FiltersSidebar } from './FiltersSidebar'
import { ViewControls } from './ViewControls'
import { ImageGrid } from './ImageGrid'

export const GalleryTab = forwardRef(function GalleryTab({
  filterOptions,
  selectedFilters,
  displayedImages,
  viewMode,
  hasMore,
  loading,
  onFilterToggle,
  onClearAllFilters,
  onViewModeChange,
  onItemClick,
  onScroll,
}, ref) {
  return (
    <>
      <FiltersSidebar
        filterOptions={filterOptions}
        selectedFilters={selectedFilters}
        onFilterToggle={onFilterToggle}
        onClearAll={onClearAllFilters}
      />

      <div className="data-explorer__main">
        <ViewControls
          viewMode={viewMode}
          onViewModeChange={onViewModeChange}
        />
        
        <ImageGrid
          ref={ref}
          items={displayedImages}
          viewMode={viewMode}
          onItemClick={onItemClick}
          onScroll={onScroll}
          hasMore={hasMore}
          loading={loading}
        />
      </div>
    </>
  )
})

